

import React, {Component} from 'react';
import {Header, Dropdown} from 'semantic-ui-react';


class PreDailyHeader extends Component {
  constructor() {
    super();
    this.state = {
      values: []
    }
  }

  render() {
    let { dailyStatementCount, monthlyStatementCount, setStatementType, setCountry, typeSelected, isLoading, cob} = this.props

    const countryList = [
      {
        key: 'country1',
        value: 'canada',
        image: { avatar: true, src: '/images/flags/CAFlagicoi.png' },
      },
      {
        key: 'country2',
        value: 'US',
        image: { avatar: true, src: '/images/flags/USFlagicoi.png' },
      }
    ]

    return (
      <>
        <div className="fullHeader" style={{height: "43px"}}>
          
          <Dropdown
            lazyLoad={true}
            inline
            options={countryList}
            defaultValue={cob}
            onChange={(e, data) => setCountry(data.value)}
            disabled
          />
          <div className='headerSectionOne statementsHeading'>
          {cob==="canada"?
          <Header className='cbpHeaderText' as='h2'>Daily Customs Statements</Header>:
          <Header className='cbpHeaderText' as='h2'>Customs Statements</Header>}
          </div>
          {cob!=="canada"?<div className='statement-filters'>
             <div onClick={() => setStatementType('DAILY')} className={`${typeSelected === 'DAILY' ? 'selected' : ''}`}>
               Daily [{!isLoading && dailyStatementCount}]
             </div>

             <div onClick={() => setStatementType('MONTHLY')} className={`${typeSelected=== 'MONTHLY' ? 'selected' : ''}`}>
               Monthly [{!isLoading && monthlyStatementCount}] 
             </div>
            
          </div>:null}
        </div>
      </>
    )
  }
}

export default PreDailyHeader;
